export const EmailNotVerified = 'EmailNotVerified';

export interface SessionResponse {
    authenticated: boolean;
    token?: string;
    message?: string;
}
